import { Injectable } from '@angular/core';
import axios from 'axios';
import { UsuarioData } from './../../common/interfaces/user-login.interface';
import { AuthService } from '@services/auth/auth.service';
import { environment, BASE_URL_SERVICIOS_USUARIOS } from "@env/environment";
import { Router } from '@angular/router';
import { ToolsService } from '@services/varios/tools.service';

@Injectable({
  providedIn: 'root'
})

export class UsuariosService {

  constructor(private readonly authService: AuthService, private readonly router: Router, private readonly toolsService: ToolsService) { }

  public async getUsuariosService(): Promise<UsuarioData[]> {
    let UsrInfo = this.authService.getUserInfo();
    let URL_TEMP:string='';
    if (UsrInfo.usuario.usarDatosNacionales) {
      URL_TEMP = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getUsuariosByIdSistema?idSistema=' + environment.idSistema;
    } else {
      URL_TEMP = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getUsuariosByIdSistemaByRegion?idSistema=' + environment.idSistema + '&numeroRegion=' + UsrInfo.usuario.direccionRegionalNumero;
    }

    const BASE_URL = URL_TEMP;

    return await axios.get(BASE_URL, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      if (resp.data.respuesta == 'ok') {
        return resp.data.usuarios;
      } else {
        let rs: UsuarioData[] = {} as UsuarioData[];
        return rs;
      }
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }

  public async getUsuariosByRutService(rut: string): Promise<any> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/getUsuarioByRutNew?rut=' + rut + '&idSistema=' + environment.idSistema;

    return await axios.get(BASE_URL, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {     
        return resp.data     
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }

  public async AddOrUpdateService(usuario: UsuarioData): Promise<UsuarioData> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/addOrUpdateUsuario';
    usuario.idSistema = environment.idSistema;
    usuario.usarSso = environment.authorizer.usarSso;
    usuario.clientID = environment.authorizer.clientId;
    usuario.apiKey = environment.authorizer.apikeysso;
    return await axios.post(BASE_URL, usuario, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      if (resp.data.respuesta == 'ok') {
        return resp.data.usuario;
      } else {
        return null;
      }
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();;
        this.router.navigate(['/']);
      }
    });
  }

  public async AddOrUpdateServiceNew(usuario: UsuarioData): Promise<any> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/addOrUpdateUsuario';
    usuario.idSistema = environment.idSistema;
    usuario.usarSso = environment.authorizer.usarSso;
    usuario.clientID = environment.authorizer.clientId;
    usuario.apiKey = environment.authorizer.apikeysso;
    return await axios.post(BASE_URL, usuario, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      return resp.data;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();;
        this.router.navigate(['/']);
      }
    });
  }

  public async updateEstadoUsuarioSistema(usuario: UsuarioData): Promise<UsuarioData> { //Estado
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/updateEstadoUsuarioSistema';
    usuario.idSistema = environment.idSistema;
    usuario.usarSso = environment.authorizer.usarSso;
    usuario.clientID = environment.authorizer.clientId;
    usuario.apiKey = environment.authorizer.apikeysso;
    return await axios.post(BASE_URL, usuario, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      if (resp.data.respuesta == 'ok') {
        return resp.data;
      } else {
        let rs: UsuarioData = {} as UsuarioData;
        return rs;
      }
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }

  public async validarUsuarioService(usuario: UsuarioData): Promise<string> {
    let UsrInfo = this.authService.getUserInfo();
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/validarUsuario';
    usuario.idSistema = environment.idSistema;
    usuario.usarSso = environment.authorizer.usarSso;
    usuario.clientID = environment.authorizer.clientId;
    usuario.apiKey = environment.authorizer.apikeysso;
    return await axios.post(BASE_URL, usuario, {
      headers: {
        Authorization: `Bearer ${UsrInfo.jwt}`,
      },
    }).then(resp => {
      return resp.data;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();;
        this.router.navigate(['/']);
      }
    });
  }

  public async cargarUsuarioService(usuario: UsuarioData): Promise<string> {
    let UsrInfo = this.authService.getUserInfo();
    let idUsuarioEjecutor: any = UsrInfo.usuario.idUsuario;
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/cargaUsuario?idUsuarioEjecutor=' + idUsuarioEjecutor;
    usuario.idSistema = environment.idSistema;
    usuario.clientID = environment.authorizer.clientId;
    usuario.apiKey = environment.authorizer.apikeysso;
    return await axios.post(BASE_URL, usuario, {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
      },
    }).then(resp => {
      return resp.data;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();;
        this.router.navigate(['/']);
      }
    });
  }

  public async generarPlantillaUsuarios(rutsData: string): Promise<string> {
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/generarPlantillaUsuarios?idSistema=' + environment.idSistema
    return await axios.post(BASE_URL, rutsData, {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
        'Content-Type': 'text/plain'
      },
      responseType: 'text',
    }).then(resp => {
      return resp.data;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();;
        this.router.navigate(['/']);
      }
    });
  }

  public async getEstadoPlantillaUsuarios(id: string): Promise<string> {
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/generarPlantillaUsuarios/' + id
    return await axios.get(BASE_URL, {
      headers: {
        apiKey: environment.apiKeyCargaUsuarios,
      },
    }).then(resp => {
      return resp.data;
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();;
        this.router.navigate(['/']);
      }
    });
  }

  public async descargarPlantillaUsuarios(id: string) {
    const BASE_URL = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/descargarPlantillaUsuarios/' + id;
    const BASE_URL_CLEAN = BASE_URL_SERVICIOS_USUARIOS + '/admin-usuario/eliminarPlantillaUsuarios/' + id;
    return await axios.post(BASE_URL,'', {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
      }, responseType: 'blob'
    }).then(async resp => {
      const now = new Date();
      const fileName = `Plantilla_Carga_Usuarios_${now.getFullYear()}-${(now.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now
          .getHours()
          .toString()
          .padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now
            .getSeconds()
            .toString()
            .padStart(2, '0')}.xlsm`;

      await axios.post(BASE_URL_CLEAN,'', {
        headers: {
          'apiKey': environment.apiKeyCargaUsuarios,
        }, responseType: 'blob'
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(resp.data);
      link.download = fileName;
      link.click();
    }).catch(async error => {
      if (error.response.status == 401) {
        sessionStorage.clear();
        await this.toolsService.errorSesionMensaje();
        this.router.navigate(['/']);
      }
    });
  }
}